import ReactDOM from 'react-dom';

import { StrictModeApp } from './components/App';
import './config/i18n';
import './config/mui';

ReactDOM.render(<StrictModeApp />, document.getElementById('root'));
